import React, { useEffect } from 'react';
import { SEO } from '../components/SEO';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
export function TermsAndConditions() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-[#FAFAFA] font-sans selection:bg-kitty-yellow-200 selection:text-kitty-dark" data-id="element-548" data-mp="2enuh20wmpl5h">
      <SEO title="Terms and Conditions | KittyPot" description="KittyPot's terms of use. The current MVP is for expense tracking and manual settlement only — KittyPot does not hold or move money." ogTitle="KittyPot Terms and Conditions" ogDescription="The terms of use for KittyPot, a shared expense and settlement tracker." path="/terms" data-id="element-549" data-mp="2amiwi9sm3q45" />
      <Navbar data-id="element-550" data-mp="1rqj4iyzmwmkk" />
      <main className="pt-32 pb-24" data-id="element-551" data-mp="1rqstcj8y0noo">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-552" data-mp="1rru8ozwzrwc7">
          <h1 className="text-4xl font-black text-kitty-dark mb-6" data-id="element-553" data-mp="3q4kfuyyq3ap2">
            Terms and Conditions
          </h1>
          <div className="prose prose-gray max-w-none text-gray-600 space-y-6" data-id="element-554" data-mp="3m1ecbz2zvxma">
            <p className="font-medium" data-id="element-555" data-mp="2p2zvib94ixgm">Last updated: 14 December 2025</p>

            <p data-id="element-556" data-mp="2u3xlvb4aext7">
              These Terms and Conditions form part of, and must be read in
              conjunction with, the Website and Mobile Application Terms and
              Conditions. KittyPot Ltd reserves the right to modify these Terms
              at any time.
            </p>

            <p data-id="element-557" data-mp="37uso44ka6gnt">
              The information provided on this website is for general
              information purposes only. This content is provided by
              https://kittypot.com (the "Website") and the KittyPot mobile
              application (the "Mobile Application"), together referred to as
              "KittyPot Ltd", "we", "us", or "our".
            </p>

            <p data-id="element-558" data-mp="3qty5ywtpoq46">
              By using this Website and/or Mobile Application, you agree to the
              following:
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-559" data-mp="3vloldh7ia42g">
              1. MVP and Services
            </h2>
            <p data-id="element-560" data-mp="9ag5vit0z3b2">
              The current KittyPot MVP is for expense tracking and manual
              settlement only. KittyPot does not currently hold funds, process
              payments, issue cards, or provide regulated e-money services.
              Users are responsible for settling their debts outside of
              KittyPot. Figures shown in the app are based entirely on
              user-entered data. KittyPot does not guarantee that users will pay
              each other.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-561" data-mp="3hoy9n8bxnwov">
              2. Waitlist Sign-Up
            </h2>
            <p data-id="element-562" data-mp="38qmmxhe6tj1p">
              By submitting your name and email address, you are joining the
              KittyPot waitlist to receive updates and notifications about our
              upcoming mobile application MVP. You consent to receive email
              communications related to your waitlist status and relevant
              product updates. You may unsubscribe at any time.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-563" data-mp="2tn3376wgs1ri">
              3. Contact Page
            </h2>
            <p data-id="element-564" data-mp="2ynhagmq8r7oh">
              You may use our contact form to reach out with questions,
              feedback, or enquiries. By submitting a message, you consent to us
              using the information provided solely to respond to your request.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-565" data-mp="2awv4r23plzhn">
              4. Accuracy of Information
            </h2>
            <p data-id="element-566" data-mp="2fuwvm97dn33o">
              We do not guarantee the accuracy, completeness, or timeliness of
              information provided on the Website or Mobile Application. Any
              reliance you place on such information is strictly at your own
              risk.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-567" data-mp="1s5u7qjm5ge0q">
              5. Limitation of Liability
            </h2>
            <p data-id="element-568" data-mp="3tw2p54qyeuak">
              To the fullest extent permitted by law, KittyPot Ltd shall not be
              liable for any direct, indirect, incidental, consequential, or
              special damages arising from your use of the Website or Mobile
              Application, including but not limited to loss of data, financial
              loss, or service interruption.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-569" data-mp="gfbqgdbm4os0">
              6. General Terms
            </h2>
            <p data-id="element-570" data-mp="ch4bno0plxjg">
              The Website and Mobile Application are provided on an "as is" and
              "as available" basis. We do not guarantee uninterrupted access,
              error-free operation, or that our services will always be secure
              or available.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-571" data-mp="2s6fp31ubh7n3">
              7. No Warranties
            </h2>
            <p data-id="element-572" data-mp="12p22ft8hpjfj">
              KittyPot Ltd expressly disclaims all warranties, whether express
              or implied, including but not limited to:
            </p>
            <ul className="list-disc pl-5 space-y-2" data-id="element-573" data-mp="17ndd266lzxyt">
              <li data-id="element-574" data-mp="szsbwhtao8tj">
                Implied warranties of merchantability or fitness for a
                particular purpose
              </li>
              <li data-id="element-575" data-mp="xwiqf0pgawcu">Non-infringement or quiet enjoyment</li>
              <li data-id="element-576" data-mp="jyaxd3vjcf6y">
                Any warranties arising from usage, trade, or course of dealing
              </li>
            </ul>
            <p data-id="element-577" data-mp="oz8cf7l90t48">
              You use our services at your own risk. It is your responsibility
              to ensure you maintain backups of any data you provide.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-578" data-mp="f0ixnnonfos7">
              8. No Guarantee of Accuracy
            </h2>
            <p data-id="element-579" data-mp="24cb7toeczvvz">
              We do not warrant that any information, recommendations, or
              content provided through our services is accurate, complete, or
              current, and we disclaim liability for any errors or omissions.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-580" data-mp="22w74mg3g2pw3">
              9. Third-Party Services
            </h2>
            <p data-id="element-581" data-mp="1xyfcpm2sv3rw">
              KittyPot Ltd makes no representations or warranties regarding any
              third-party services, tools, or advice that may be referenced or
              integrated into our services.
            </p>
            <p data-id="element-582" data-mp="2lo01illmwv93">
              We aim to keep the Website and Mobile Application running
              smoothly, however KittyPot Ltd will not be liable for temporary
              unavailability due to technical issues beyond our reasonable
              control.
            </p>

            <p className="mt-8" data-id="element-583" data-mp="2ctlkoelghcnv">
              If you have questions about these Terms, please contact us via our
              online contact form.
            </p>

            <hr className="border-gray-200 my-12" data-id="element-584" data-mp="34l182auu73f5" />

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-585" data-mp="r47vc9im2z8s">
              Competition Entry Disclosure
            </h2>
            <p data-id="element-586" data-mp="w3u7sgqm8bgj">
              If KittyPot Ltd runs promotional competitions in the future,
              participation will be subject to the following conditions:
            </p>

            <h3 className="text-xl font-bold text-kitty-dark mt-8 mb-3" data-id="element-587" data-mp="153zf6qvt79up">
              1. Eligibility
            </h3>
            <p data-id="element-588" data-mp="1a20ztg8vvh8a">
              Competitions are open only to residents of the United Kingdom who
              are aged 18 or over at the time of entry.
            </p>

            <h3 className="text-xl font-bold text-kitty-dark mt-8 mb-3" data-id="element-589" data-mp="1js3qvawg2l3z">
              2. Prize Distribution
            </h3>
            <p data-id="element-590" data-mp="1nsxdm0y5htva">
              Any prizes awarded will be distributed according to the specific
              rules of that competition.
            </p>

            <h3 className="text-xl font-bold text-kitty-dark mt-8 mb-3" data-id="element-591" data-mp="1xsejaidek7r9">
              3. Prize Allocation
            </h3>
            <p data-id="element-592" data-mp="18og7j6aqcksn">
              Unless stated otherwise, only one prize will be awarded per
              competition. Full details of prizes and distribution will be
              communicated separately.
            </p>

            <p className="mt-8" data-id="element-593" data-mp="1homhwjb4t4nl">
              By entering a competition, you confirm that you meet the
              eligibility requirements and agree to all applicable terms and
              conditions.
            </p>
          </div>
        </div>
      </main>
      <Footer data-id="element-594" data-mp="kzwz8qrok80k" />
    </div>;
}